import { ClubBookingApiClient } from "../../common/api/ClubBookingApiClient";
import {
    RecurringMemberItemCatalog,
    RecurringMemberItem,
    AddMemberRecurringItemsRequest,
} from "../../model/recurring/RecurringMemberItems";

export class RecurringMemberItemsService extends ClubBookingApiClient {
    async getCatalogItems(): Promise<RecurringMemberItemCatalog[]> {
        return this.get<RecurringMemberItemCatalog[]>("/members/dditems");
    }

    async getMemberRecurringItems(membershipId: string): Promise<RecurringMemberItem[]> {
        return this.get<RecurringMemberItem[]>(`/members/dditems/${membershipId}`);
    }

    async createCatalogItem(request: RecurringMemberItemCatalog): Promise<void> {
        await this.post("/members/dditems/create", request, {
            successMessage: "Recurring item created successfully",
        });
    }

    async addItemsToMember(requests: AddMemberRecurringItemsRequest[]): Promise<void> {
        await this.post("/members/dditems/add", requests, {
            successMessage: "Recurring items saved successfully",
        });
    }

    /**
     * Clears every recurring item from a member.
     *
     * The counterpart to addItemsToMember, which replaces a member's items from the
     * payload it is given and so cannot express "none left" — an empty list carries no
     * membership id to apply it to. Removing a member's last item is a real save, not
     * a no-op, so it needs a door of its own.
     */
    async removeAllItemsFromMember(membershipId: string): Promise<void> {
        await this.delete(`/members/dditems/${membershipId}`, {
            successMessage: "Recurring items saved successfully",
        });
    }
}
